export type IGetDifferenceOfNums = (num1: number, num2: number, float: number) => number;

export function getDifferenceOfNums(num1: number, num2: number, float: number): number {
  let diff = num1 > num2 ? Math.abs(num1 - num2) : Math.abs(num2 - num1);
  diff = Number(parseFloat(diff.toString()).toFixed(float));
  return diff;
}
